/**
 * @generated SignedSource<<25d995076ddeddd00e384bb6d2f93c78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksDebouncedAutoCompleteQuery$variables = {
  query: string;
};
export type hooksDebouncedAutoCompleteQuery$data = {
  readonly autoCompleteSearch: {
    readonly suggestions: ReadonlyArray<string>;
  } | null | undefined;
};
export type hooksDebouncedAutoCompleteQuery = {
  response: hooksDebouncedAutoCompleteQuery$data;
  variables: hooksDebouncedAutoCompleteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "AutoCompleteSearchResult",
    "kind": "LinkedField",
    "name": "autoCompleteSearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "suggestions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksDebouncedAutoCompleteQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksDebouncedAutoCompleteQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ee28dad02c843ff6f289ba6b47f67d93",
    "id": null,
    "metadata": {},
    "name": "hooksDebouncedAutoCompleteQuery",
    "operationKind": "query",
    "text": "query hooksDebouncedAutoCompleteQuery(\n  $query: String!\n) {\n  autoCompleteSearch(query: $query) {\n    suggestions\n  }\n}\n"
  }
};
})();

(node as any).hash = "f571e7bcd8e7139937e2098587b0d241";

export default node;
